import { FormError } from '@components/form-error';
import { JsonEditor } from '@components/json-editor';
import { Spinner } from '@components/loading-spinner';
import { Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';
import { abbreviateDate } from '@utils/date';

import { useJourneyWebhookLog } from 'api/journey-webhooks/hooks';

export const usePreviewWebhookLog = () => useModal(PreviewWebhookLog, { variant: 'LARGE' });

type PreviewWebhookLogProps = {
  webhookShortId: string;
  webhookLogShortId: string;
};

export const PreviewWebhookLog = ({
  webhookShortId,
  webhookLogShortId,
}: PreviewWebhookLogProps) => {
  const { t } = useScopedTranslate(locale);
  const { data: webhookLog, isLoading } = useJourneyWebhookLog(webhookShortId, webhookLogShortId);

  if (!webhookLog || isLoading) {
    return <Spinner />;
  }
  return (
    <Modal>
      <Modal.SimpleHeader title={abbreviateDate(webhookLog.triggeredOnDate, 'en')} />
      <Modal.Content>
        <Stack space={2}>
          <JsonEditor label={t('payload')} initialValue={webhookLog.payload} isDisabled />
          <FormError text={webhookLog.errorMessage} />
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

export const locale = {
  en: {
    payload: 'Payload',
  },
};
